/**
 * Shared date/time formatting and range utilities.
 */

export function formatTime24(iso, timeZone) {
  if (!iso) return '';
  try {
    const d = new Date(iso);
    const fmt = new Intl.DateTimeFormat('en-GB', {
      timeZone: timeZone || 'UTC',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23',
    });
    return fmt.format(d);
  } catch {
    return '';
  }
}

export function formatDateLocal(iso, timeZone) {
  if (!iso) return '';
  try {
    const d = new Date(iso);
    const fmt = new Intl.DateTimeFormat('en-CA', {
      timeZone: timeZone || 'UTC',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });
    return fmt.format(d);
  } catch {
    return '';
  }
}

export function formatDateReadable(dateStr) {
  if (!dateStr) return '';
  const parts = String(dateStr).split('-').map((x) => Number(x));
  if (parts.length >= 3 && parts.every(Number.isFinite)) {
    const d = new Date(parts[0], parts[1] - 1, parts[2]);
    return d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
  }
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return dateStr;
  return d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
}

export function formatWeekday(dateStr) {
  if (!dateStr) return '';
  const parts = String(dateStr).split('-').map((x) => Number(x));
  if (parts.length >= 3 && parts.every(Number.isFinite)) {
    const d = new Date(parts[0], parts[1] - 1, parts[2]);
    return d.toLocaleDateString('en-US', { weekday: 'long' });
  }
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('en-US', { weekday: 'long' });
}

export function getDatesInRange(start, end) {
  const parse = (s) => {
    const parts = String(s || '').slice(0, 10).split('-').map(Number);
    if (parts.length >= 3 && parts.every(Number.isFinite)) {
      return new Date(parts[0], parts[1] - 1, parts[2]);
    }
    return null;
  };
  const sDate = parse(start);
  const eDate = parse(end);
  if (!sDate || !eDate || sDate > eDate) return [];

  const days = [];
  for (let d = new Date(sDate); d <= eDate; d.setDate(d.getDate() + 1)) {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    days.push(`${y}-${m}-${day}`);
  }
  return days;
}

export function getDatesForDestination(dest) {
  return getDatesInRange(dest.start_date, dest.end_date);
}
